import axios from 'axios'
//  使用 qs  打包 传递参数
// import qs from 'qs'

let axiosConfig = {
    baseURL: window.$baseUrl === undefined ? 'http://192.168.1.11/chartQuery' : window.$baseUrl,
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 60000 // request timeout
}

let server = axios.create(axiosConfig)


// 发送Post数据
function Post(type, msg) {
    // 要发送的数据
    let param = msg.data
    // 接收返回的回调函数
    let fn = msg.fn
    // 回调函数运行的this指针
    let vm = msg.vm

    let url = '/api/' + type
    let config = {
        params: param,
    }
    // console.info('send post:', JSON.stringify(config))

    server.post(url, config)
        .then((res) => {
            //  服务器响应数据在这里面
            let resdata = res.data
            // console.debug('post: ', resdata)
            if (fn === null || fn === undefined) {
                return
            }
            fn.call(vm, resdata)
        })
        .catch((e) => {
            if (fn === null || fn === undefined) {
                return
            }

            if (e.message === 'Network Error') {
                fn.call(vm, null)
            }

            console.error('post: ', e)
        })
}

// 发送Get数据
function Get(type, msg) {
    // 要发送的数据
    let param = msg.data
    // 接收返回的回调函数
    let fn = msg.fn
    // 回调函数运行的this指针
    let vm = msg.vm


    let url = type

    server.get(url, param)
        .then((res) => {
            // console.log('Get: ', res.data)
            if (fn === null || fn === undefined) {
                return
            }
            fn.call(vm, res.data)
        })
        .catch((e) => {
            if (fn === null || fn === undefined) {
                return
            }
            if (e.message === 'Network Error') {
                fn.call(vm, null)
            }
            // console.log('get: ', e)
            console.error('get: ', e)
        })
}

export {
    server,
    Get,
    Post
}
